/* ==========================================================================
   DIREVULF — cart-page.js
   The bag page (sections/main-cart.liquid). Loaded only by that section.

   WHAT IT DOES
   - Quantity, size, remove (with Undo), save for later, move to wishlist.
   - Coupons through Shopify's own cart API (Shopify decides if a code is good).
   - Gift message, saved as the cart note.
   - Delivery date by pincode, from the same Shipway source as the product page.
   - Share your bag, and a friend's shared bag.
   - "Complete the look" and "From your wishlist" rails.
   - Updates the page IN PLACE from the section Shopify re-renders after every
     change: lines are patched by key, regions by name, focus is kept, open
     panels stay open, and nothing flashes.

   WHAT IT NEVER DOES
   - Format money. Every amount on the page comes out of Liquid, including the
     saved and shared rows (sections/cart-item-card.liquid).
   - Invent anything: no timers, stock claims or made-up dates.
   - Touch checkout. The checkout buttons are plain submits named "checkout",
     which is what Razorpay Magic Checkout listens for.
   ========================================================================== */
(function () {
  'use strict';

  var C = { t: {} };
  var ROOT = '/';
  var SAVED_KEY = 'dv:bag:saved';
  var PIN_KEY = 'dv:pin';
  var ITEM_SECTION = 'cart-item-card';
  var RECS_SECTION = 'cart-recommendations';
  var WISH_SECTION = 'wishlist-card';
  var REDUCE = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  /* Only a mouse can rest on the bag notice. After a tap, a phone's browser
     keeps reporting :hover (and focus on the tapped button) until the next
     tap, which held the notice open; on touch screens neither does now. */
  var CAN_HOVER = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function root() { return $('[data-dvb]'); }
  function base() { return ROOT.replace(/\/$/, ''); }

  function readConfig() {
    var node = $('[data-dvb-config]');
    if (!node) return;
    try {
      var c = JSON.parse(node.textContent);
      if (c && typeof c === 'object') { C = c; C.t = c.t || {}; ROOT = c.root || '/'; }
    } catch (e) { /* keep defaults */ }
  }
  function t(key, vars) {
    var s = (C.t && C.t[key]) || '';
    Object.keys(vars || {}).forEach(function (k) { s = s.split('%' + k.toUpperCase() + '%').join(String(vars[k])); });
    return s;
  }
  function announce(message) {
    if (message && window.Direvulf && window.Direvulf.announce) window.Direvulf.announce(message);
  }
  function byKey(scope, key) {
    var found = null;
    $$('[data-dvb-line]', scope).some(function (li) {
      if (li.getAttribute('data-key') === key) { found = li; return true; }
      return false;
    });
    return found;
  }

  /* ----------------------------------------------------------- network */
  /* Cart writes are serialised: Shopify's cart is one shared object, and the
     page is re-rendered from each answer in the order the answers arrive. */
  var chain = Promise.resolve();
  function queue(task) {
    var run = chain.then(task);
    chain = run.catch(function () {});
    /* cart.js holds a checkout click until this has landed (Magic Checkout
       reads the cart the moment it opens). */
    if (window.DirevulfCart && window.DirevulfCart.track) window.DirevulfCart.track(run);
    return run;
  }

  function sectionIds() {
    return (window.DirevulfCart && window.DirevulfCart.sectionIds) ? window.DirevulfCart.sectionIds() : [];
  }

  function cartPost(path, body, withSections) {
    body = body || {};
    if (withSections !== false) {
      var ids = sectionIds();
      if (ids.length) { body.sections = ids.join(','); body.sections_url = C.cartUrl || '/cart'; }
    }
    busy(true);
    return fetch(ROOT + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (json) {
        if (!response.ok) {
          var error = new Error(json.description || json.message || t('error'));
          error.status = response.status;
          throw error;
        }
        return json;
      });
    }).finally(function () { busy(false); });
  }

  /* Apply what Shopify rendered with the change (drawer, header count and
     this page together), or ask for it when it did not come back. */
  function settle(json) {
    if (json && json.sections && window.DirevulfCart && window.DirevulfCart.apply) {
      window.DirevulfCart.apply(json.sections);
      return Promise.resolve(json);
    }
    return refreshAll().then(function () { return json; });
  }
  function refreshAll() {
    if (window.DirevulfCart && window.DirevulfCart.refresh) return window.DirevulfCart.refresh().catch(function () {});
    return Promise.resolve();
  }

  var busyCount = 0;
  function busy(on) {
    busyCount = Math.max(0, busyCount + (on ? 1 : -1));
    var r = root();
    var state = busyCount > 0;
    if (r) r.classList.toggle('is-syncing', state);
  }

  /* -------------------------------------------------------------- toast */
  var toastTimer = 0;
  var toastFn = null;
  function toast(message, action) {
    var box = $('[data-dvb-toast]');
    if (!box) { announce(message); return; }
    var text = $('[data-dvb-toast-text]', box);
    var btn = $('[data-dvb-toast-act]', box);
    var link = $('[data-dvb-toast-link]', box);
    text.textContent = message || '';
    btn.hidden = true; link.hidden = true; toastFn = null;
    if (action && action.fn) { btn.textContent = action.label; btn.hidden = false; toastFn = action.fn; }
    else if (action && action.href) { link.textContent = action.label; link.setAttribute('href', action.href); link.hidden = false; }
    box.hidden = false;
    void box.offsetWidth; /* commit the hidden state so the slide-in runs */
    box.classList.add('is-in');
    armToast(action ? 6000 : 3200);
  }
  function armToast(ms) {
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(hideToast, ms);
  }
  /* Focus inside the notice keeps it up for keyboard users; a tap's focus
     does not. */
  function focusHolds(box) {
    var a = document.activeElement;
    if (!a || !box.contains(a)) return false;
    if (CAN_HOVER) return true;
    try { return a.matches(':focus-visible'); } catch (e) { return true; }
  }
  function hideToast() {
    var box = $('[data-dvb-toast]');
    if (!box) return;
    if ((CAN_HOVER && box.matches(':hover')) || focusHolds(box)) { armToast(2000); return; }
    box.classList.remove('is-in');
    toastFn = null;
    window.setTimeout(function () { if (!box.classList.contains('is-in')) box.hidden = true; }, REDUCE ? 0 : 260);
  }

  /* ---------------------------------------------------------- the lines */
  function lineOf(el) { return el && el.closest ? el.closest('[data-dvb-line]') : null; }
  function lineData(li) {
    var props = {};
    try { props = JSON.parse(li.getAttribute('data-props') || '{}') || {}; } catch (e) { props = {}; }
    return {
      key: li.getAttribute('data-key'),
      id: li.getAttribute('data-variant-id'),
      productId: li.getAttribute('data-product-id'),
      handle: li.getAttribute('data-handle'),
      qty: parseInt(li.getAttribute('data-qty'), 10) || 1,
      title: li.getAttribute('data-title') || '',
      price: parseInt(li.getAttribute('data-price'), 10),
      available: li.getAttribute('data-available') === 'true',
      plan: li.getAttribute('data-plan') || '',
      props: props
    };
  }
  function itemFrom(d) {
    var item = { id: Number(d.id), quantity: d.qty || d.quantity || 1 };
    var props = d.props || d.properties;
    if (props && Object.keys(props).length) item.properties = props;
    if (d.plan) item.selling_plan = Number(d.plan);
    return item;
  }

  function collapse(li) {
    return new Promise(function (resolve) {
      if (!li || !li.parentNode) { resolve(); return; }
      li.classList.add('is-leaving');
      if (REDUCE) { li.remove(); resolve(); return; }
      li.style.height = li.getBoundingClientRect().height + 'px';
      void li.offsetHeight;
      li.style.height = '0px';
      var done = false;
      function finish() { if (done) return; done = true; li.remove(); resolve(); }
      li.addEventListener('transitionend', function (e) {
        if (e.target === li && e.propertyName === 'height') finish();
      });
      window.setTimeout(finish, 480);
    });
  }

  function nextFocusKey(li) {
    var next = li.nextElementSibling;
    while (next && next.classList.contains('is-leaving')) next = next.nextElementSibling;
    var prev = li.previousElementSibling;
    while (prev && prev.classList.contains('is-leaving')) prev = prev.previousElementSibling;
    var target = next || prev;
    return target ? target.getAttribute('data-key') : null;
  }
  function focusLineOrHead(key) {
    var r = root();
    var li = key && byKey(r, key);
    var target = li ? $('[data-dvb-f="title"]', li) : $('.dvb-title', r);
    if (!target) return;
    if (!li) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: false });
  }

  /* Remove a line, animate it away, then run `after` (save for later, the
     wishlist) and say so — with Undo when the caller gives one. */
  function removeFlow(li, opts) {
    var d = lineData(li);
    var hadFocus = li.contains(document.activeElement);
    var focusKey = nextFocusKey(li);
    li.classList.add('is-busy');
    if (opts.before) opts.before(d);
    var anim = collapse(li);
    return queue(function () {
      return Promise.all([cartPost('cart/change.js', { id: d.key, quantity: 0 }), anim])
        .then(function (res) { return settle(res[0]); });
    }).then(function () {
      if (opts.message) toast(opts.message, opts.action ? opts.action(d) : null);
      if (hadFocus) focusLineOrHead(focusKey);
      if (opts.after) opts.after(d);
    }).catch(function (error) {
      toast(error.message || t('error'));
      return refreshAll();
    });
  }

  function addBack(d) {
    return queue(function () {
      return cartPost('cart/add.js', { items: [itemFrom(d)] }).then(settle);
    }).then(function () { toast(t('restored')); })
      .catch(function (error) { toast(error.message || t('error')); });
  }

  function onRemove(li) {
    removeFlow(li, {
      message: t('removed'),
      action: function (d) { return { label: t('undo'), fn: function () { addBack(d); } }; }
    });
  }

  function onSave(li) {
    removeFlow(li, {
      message: t('saved'),
      before: function (d) {
        var list = readSaved().filter(function (e) { return String(e.id) !== String(d.id); });
        list.unshift({ id: d.id, handle: d.handle, quantity: d.qty, properties: d.props });
        writeSaved(list);
      },
      after: function () { renderSaved(); }
    });
  }

  function onWish(li) {
    removeFlow(li, {
      message: t('moved_wish'),
      action: function () { return { label: t('view'), href: C.wishlistUrl || '/pages/wishlist' }; },
      before: function (d) {
        if (!window.DirevulfWishlist) return;
        window.DirevulfWishlist.add({
          id: d.productId,
          handle: d.handle,
          price: isNaN(d.price) ? null : d.price,
          available: d.available
        });
        window.DirevulfWishlist.render();
        document.dispatchEvent(new CustomEvent('dv:wishlist:change', { detail: { id: d.productId, saved: true } }));
      }
    });
  }

  /* Quantity: the number changes at once; Shopify is asked once the taps stop,
     with the final figure, so a quick +++ is one request and never flickers. */
  function setQtyText(li, n) {
    var val = $('[data-dvb-qty-val]', li);
    if (val) val.innerHTML = '<span class="visually-hidden">Quantity </span>' + n;
    var minus = $('[data-dvb-step="-1"]', li);
    if (minus) minus.disabled = n <= 1;
  }
  function onStep(btn) {
    var li = lineOf(btn);
    if (!li) return;
    var d = lineData(li);
    var next = d.qty + (parseInt(btn.getAttribute('data-dvb-step'), 10) || 0);
    if (next < 1) return;
    li.setAttribute('data-qty', String(next));
    setQtyText(li, next);
    li.__pending = true;
    window.clearTimeout(li.__timer);
    li.__fire = function () {
      li.__timer = 0;
      var key = li.getAttribute('data-key');
      var want = parseInt(li.getAttribute('data-qty'), 10) || 1;
      li.classList.add('is-busy');
      queue(function () {
        return cartPost('cart/change.js', { id: key, quantity: want }).then(function (json) {
          li.__pending = false;
          return settle(json);
        });
      }).then(function () { announce(t('updated')); })
        .catch(function (error) {
          li.__pending = false;
          toast(error.message || t('error'));
          return refreshAll();
        });
    };
    li.__timer = window.setTimeout(li.__fire, 380);
  }

  /* Checkout is about to read the cart: send any quantity still waiting on
     its debounce and a gift message not yet saved, now. */
  function flushForCheckout() {
    var started = false;
    $$('[data-dvb-line]').forEach(function (li) {
      if (li.__timer && li.__fire) {
        window.clearTimeout(li.__timer);
        li.__fire();
        started = true;
      }
    });
    var gm = $('[data-dvb-gift-msg]');
    if (gm && giftNote(gm.value) !== giftLast) {
      window.clearTimeout(giftTimer);
      giftSave(gm.value);
      started = true;
    }
    return started ? chain : null;
  }

  /* Size: add the new size with the same quantity, then take the old line out.
     If Shopify refuses the new size, nothing was removed. */
  function onSize(select) {
    var li = lineOf(select);
    if (!li) return;
    var d = lineData(li);
    var newId = String(select.value);
    if (!newId || newId === String(d.id)) return;
    var option = select.options[select.selectedIndex];
    var label = (option && option.getAttribute('data-size')) || '';
    li.classList.add('is-busy');
    queue(function () {
      return cartPost('cart/add.js', { items: [{ id: Number(newId), quantity: d.qty }] }, false)
        .then(function () { return cartPost('cart/change.js', { id: d.key, quantity: 0 }); })
        .then(settle);
    }).then(function () {
      toast(t('size_changed', { size: label }));
      var fresh = null;
      $$('[data-dvb-line]').some(function (node) {
        if (node.getAttribute('data-variant-id') === newId) { fresh = node; return true; }
        return false;
      });
      if (fresh) {
        fresh.classList.add('is-new');
        window.setTimeout(function () { fresh.classList.remove('is-new'); }, 1600);
        var sel = $('[data-dvb-size]', fresh);
        if (sel) sel.focus({ preventScroll: true });
        if (fresh.scrollIntoView) fresh.scrollIntoView({ block: 'nearest', behavior: REDUCE ? 'auto' : 'smooth' });
      }
    }).catch(function (error) {
      select.value = String(d.id);
      li.classList.remove('is-busy');
      toast(error.message || t('error'));
      return refreshAll();
    });
  }

  /* -------------------------------------------------------- saved for later */
  /* Held on this device: the variant, how many, and the line properties. No
     price is stored — the row is re-rendered by Liquid every time. */
  function readSaved() {
    try {
      var raw = window.localStorage.getItem(SAVED_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) { return []; }
  }
  function writeSaved(list) {
    try { window.localStorage.setItem(SAVED_KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
    return list;
  }
  function dropSaved(id) {
    return writeSaved(readSaved().filter(function (e) { return String(e.id) !== String(id); }));
  }

  /* One product + variant, rendered by Shopify. Resolves {card} or {drop:true}
     when the product or that variant no longer exists; {} on a network error,
     so a saved item is never thrown away because the connection blinked. */
  function fetchCard(handle, id) {
    var url = base() + '/products/' + encodeURIComponent(handle)
      + '?section_id=' + ITEM_SECTION + '&variant=' + encodeURIComponent(id);
    return fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (response) {
        if (response.status === 404) return { drop: true };
        if (!response.ok) return {};
        return response.text().then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('[data-dvb-card]');
          if (!card) return { drop: true };
          if (String(card.getAttribute('data-variant-id')) !== String(id)) return { drop: true };
          return { card: document.importNode(card, true) };
        });
      })
      .catch(function () { return {}; });
  }

  function cardButton(label, attr, cls) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls === 'act' ? 'dvb-act dvb-act--remove' : 'dvb-btn dvb-btn--sm ' + (cls || 'dvb-btn--ghost');
    b.setAttribute(attr, '');
    b.textContent = label;
    return b;
  }
  function qtyNote(card, qty) {
    var q = $('[data-dvb-card-qty]', card);
    if (!q) return;
    var meta = q.parentNode;
    var sep = meta && meta.textContent.replace(q.textContent, '').trim() ? ' · ' : '';
    q.textContent = qty > 1 ? sep + t('qty') + ' ' + qty : '';
  }

  var savedRun = 0;
  function renderSaved() {
    var host = $('[data-dvb-saved]');
    var list = host && $('[data-dvb-saved-list]', host);
    if (!host || !list) return Promise.resolve();
    var saved = readSaved();
    var run = ++savedRun;
    if (!saved.length) { list.innerHTML = ''; host.hidden = true; return Promise.resolve(); }
    return Promise.all(saved.map(function (e) {
      return e && e.handle && e.id ? fetchCard(e.handle, e.id) : Promise.resolve({ drop: true });
    })).then(function (results) {
      if (run !== savedRun) return;
      var keep = [];
      var frag = document.createDocumentFragment();
      results.forEach(function (res, i) {
        if (res.drop) return;
        keep.push(saved[i]);
        if (!res.card) return;
        var card = res.card;
        qtyNote(card, parseInt(saved[i].quantity, 10) || 1);
        var actions = $('[data-dvb-card-actions]', card);
        if (actions) {
          var name = (($('.dvb-mini__title', card) || {}).textContent || '').trim();
          var btn;
          if (card.getAttribute('data-available') === 'true') {
            btn = actions.appendChild(cardButton(t('move_to_bag'), 'data-dvb-saved-add', 'dvb-btn--dark'));
            if (name) btn.setAttribute('aria-label', t('move_to_bag') + ': ' + name);
          }
          btn = actions.appendChild(cardButton(t('remove'), 'data-dvb-saved-drop', 'act'));
          if (name) btn.setAttribute('aria-label', t('remove') + ': ' + name);
        }
        frag.appendChild(card);
      });
      if (keep.length !== saved.length) writeSaved(keep);
      list.innerHTML = '';
      list.appendChild(frag);
      var count = $('[data-dvb-saved-count]', host);
      if (count) count.textContent = list.children.length ? String(list.children.length) : '';
      host.hidden = list.children.length === 0;
    });
  }

  function onSavedAdd(card) {
    var id = card.getAttribute('data-variant-id');
    var entry = readSaved().filter(function (e) { return String(e.id) === String(id); })[0];
    if (!entry) return;
    card.classList.add('is-busy');
    queue(function () {
      return cartPost('cart/add.js', { items: [itemFrom(entry)] }).then(settle);
    }).then(function () {
      dropSaved(id);
      return renderSaved();
    }).then(function () { toast(t('moved_bag')); })
      .catch(function (error) {
        card.classList.remove('is-busy');
        toast(error.message || t('error'));
      });
  }
  function onSavedDrop(card) {
    dropSaved(card.getAttribute('data-variant-id'));
    card.classList.add('is-busy');
    renderSaved();
  }

  /* ------------------------------------------------------- shared bags */
  function parseShared() {
    var raw = '';
    try { raw = new URLSearchParams(window.location.search).get('shared') || ''; } catch (e) { raw = ''; }
    if (!raw) return [];
    var seen = {};
    return raw.split(',').slice(0, 20).map(function (part) {
      var a = part.split('~');
      var id = parseInt(a[0], 10);
      var qty = parseInt(a[1], 10);
      var handle = String(a[2] || '').toLowerCase();
      if (!(id > 0) || !(qty >= 1 && qty <= 20) || !/^[a-z0-9][a-z0-9-]{0,254}$/.test(handle) || seen[id]) return null;
      seen[id] = true;
      return { id: id, quantity: qty, handle: handle };
    }).filter(Boolean);
  }
  function stripShared() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('shared');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch (e) { /* old browser: the param stays, harmlessly */ }
  }
  function renderShared() {
    var host = $('[data-dvb-shared]');
    var items = parseShared();
    if (!host || !items.length) return;
    var list = $('[data-dvb-shared-list]', host);
    var sub = $('[data-dvb-shared-sub]', host);
    var add = $('[data-dvb-shared-add]', host);
    Promise.all(items.map(function (e) { return fetchCard(e.handle, e.id); })).then(function (results) {
      list.innerHTML = '';
      var ok = [];
      results.forEach(function (res, i) {
        if (!res.card) return;
        qtyNote(res.card, items[i].quantity);
        if (res.card.getAttribute('data-available') === 'true') ok.push(items[i]);
        list.appendChild(res.card);
      });
      host.__items = ok;
      if (!ok.length) {
        if (sub) sub.textContent = t('shared_none');
        if (add) add.hidden = true;
      } else if (sub) {
        var n = ok.reduce(function (s, e) { return s + e.quantity; }, 0);
        sub.textContent = n === 1 ? t('shared_one') : t('shared_many', { n: n });
      }
      host.hidden = false;
    });
  }
  function onSharedAdd(host) {
    var items = host.__items || [];
    if (!items.length) return;
    var btn = $('[data-dvb-shared-add]', host);
    if (btn) btn.disabled = true;
    queue(function () {
      return cartPost('cart/add.js', { items: items.map(function (e) { return { id: e.id, quantity: e.quantity }; }) })
        .then(settle)
        .catch(function () {
          /* One of them could not be added (sold out since): add the rest one
             by one rather than none at all. */
          return items.reduce(function (p, e) {
            return p.then(function () {
              return cartPost('cart/add.js', { items: [{ id: e.id, quantity: e.quantity }] }, false).catch(function () {});
            });
          }, Promise.resolve()).then(refreshAll);
        });
    }).then(function () {
      host.hidden = true;
      stripShared();
      toast(t('shared_added'));
    }).catch(function (error) {
      if (btn) btn.disabled = false;
      toast(error.message || t('error'));
    });
  }

  /* ------------------------------------------------------- share my bag */
  function shareUrl() {
    var parts = $$('[data-dvb-line]').filter(function (li) {
      return li.getAttribute('data-shareable') === 'true' && !li.classList.contains('is-leaving');
    }).map(function (li) {
      return li.getAttribute('data-variant-id') + '~' + li.getAttribute('data-qty') + '~' + li.getAttribute('data-handle');
    });
    return window.location.origin + base() + '/cart?shared=' + encodeURIComponent(parts.join(','));
  }
  function closeShare() {
    var menu = $('[data-dvb-share-menu]');
    var btn = $('[data-dvb-share-open]');
    if (menu) menu.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }
  function onShareOpen(btn) {
    var url = shareUrl();
    var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    if (coarse && navigator.share) {
      navigator.share({ title: t('share_title'), text: t('share_text'), url: url }).catch(function () {});
      return;
    }
    var menu = $('[data-dvb-share-menu]');
    if (!menu) return;
    var open = menu.hidden;
    menu.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
  }
  function copyOld(text) {
    return new Promise(function (resolve, reject) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      area.remove();
      if (ok) resolve(); else reject(new Error('copy'));
    });
  }
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () { return copyOld(text); });
    }
    return copyOld(text);
  }
  /* When the browser will not let the page copy (a locked-down in-app
     browser, say), the link is shown, selected, for the shopper to copy. */
  function showLinkField(link) {
    var menu = $('[data-dvb-share-menu]');
    if (!menu) { toast(t('error')); return; }
    var field = $('[data-dvb-share-url]', menu);
    if (!field) {
      field = document.createElement('input');
      field.type = 'text';
      field.readOnly = true;
      field.className = 'dvb-input';
      field.setAttribute('data-dvb-share-url', '');
      field.setAttribute('aria-label', t('share_title') || 'Link');
      field.style.marginTop = '10px';
      menu.appendChild(field);
    }
    field.value = link;
    menu.hidden = false;
    var open = $('[data-dvb-share-open]');
    if (open) open.setAttribute('aria-expanded', 'true');
    field.focus();
    field.select();
    toast(t('copy_manual') || 'Copy the link to share your bag.');
  }

  /* ------------------------------------------------------------ coupons */
  function appliedCodes() {
    var region = $('[data-dvb-region="codes"]');
    return ((region && region.getAttribute('data-codes')) || '').split(',')
      .map(function (s) { return s.trim(); }).filter(Boolean);
  }
  function couponMsg(text, tone) {
    var node = $('[data-dvb-coupon-msg]');
    if (!node) return;
    node.textContent = text || '';
    node.hidden = !text;
    node.classList.toggle('is-error', tone === 'error');
    node.classList.toggle('is-ok', tone === 'ok');
    var input = $('[data-dvb-code]');
    if (input) {
      if (tone === 'error') { input.setAttribute('aria-invalid', 'true'); input.setAttribute('aria-describedby', 'DvbCouponMsg'); }
      else { input.removeAttribute('aria-invalid'); input.removeAttribute('aria-describedby'); }
    }
  }
  function onCoupon(form) {
    var input = $('[data-dvb-code]', form);
    var code = input ? input.value.trim() : '';
    if (!code) { couponMsg(t('coupon_empty'), 'error'); if (input) input.focus(); return; }
    var current = appliedCodes();
    var lower = code.toLowerCase();
    if (current.some(function (c) { return c.toLowerCase() === lower; })) {
      couponMsg(t('coupon_ok', { code: code.toUpperCase() }), 'ok');
      return;
    }
    var button = $('button[type="submit"]', form);
    if (button) button.disabled = true;
    couponMsg('', '');
    queue(function () {
      return cartPost('cart/update.js', { discount: current.concat([code]).join(',') }).then(function (json) {
        var hit = (json.discount_codes || []).filter(function (c) { return String(c.code).toLowerCase() === lower; })[0];
        if (hit && hit.applicable) return settle(json).then(function () { return true; });
        /* Shopify says no: put the bag back exactly as it was. */
        return cartPost('cart/update.js', { discount: current.join(',') }).then(settle).then(function () { return false; });
      });
    }).then(function (ok) {
      if (ok) {
        if (input) input.value = '';
        couponMsg(t('coupon_ok', { code: code.toUpperCase() }), 'ok');
        announce(t('coupon_ok', { code: code.toUpperCase() }));
      } else {
        couponMsg(t('coupon_bad', { code: code.toUpperCase() }), 'error');
      }
    }).catch(function (error) {
      couponMsg(error.message || t('error'), 'error');
    }).then(function () { if (button) button.disabled = false; });
  }
  function onCouponRemove(code) {
    var rest = appliedCodes().filter(function (c) { return c.toLowerCase() !== String(code).toLowerCase(); });
    queue(function () {
      return cartPost('cart/update.js', { discount: rest.join(',') }).then(settle);
    }).then(function () {
      couponMsg('', '');
      toast(t('coupon_removed'));
      var input = $('[data-dvb-code]');
      if (input) input.focus({ preventScroll: true });
    }).catch(function (error) { toast(error.message || t('error')); });
  }

  /* --------------------------------------------------------- gift note */
  var giftTimer = 0;
  var giftLast = null;
  function giftNote(text) { return text.trim() ? (C.giftPrefix || '') + text.trim() : ''; }
  function giftSave(text) {
    var note = giftNote(text);
    if (note === giftLast) return Promise.resolve();
    giftLast = note;
    var status = $('[data-dvb-gift-status]');
    if (status) { status.textContent = t('gift_saving'); status.className = 'is-saving'; }
    return queue(function () {
      return cartPost('cart/update.js', { note: note }, false);
    }).then(function () {
      var s = $('[data-dvb-gift-status]');
      if (s) { s.textContent = note ? t('gift_saved') : ''; s.className = 'is-saved'; }
    }).catch(function (error) {
      giftLast = null;
      var s = $('[data-dvb-gift-status]');
      if (s) { s.textContent = error.message || t('error'); s.className = 'is-error'; }
    });
  }
  function onGiftToggle(input) {
    var panel = input.closest('[data-dvb-gift]');
    var body = panel && $('[data-dvb-gift-body]', panel);
    var msg = panel && $('[data-dvb-gift-msg]', panel);
    if (!panel || !body) return;
    panel.classList.toggle('is-on', input.checked);
    body.hidden = !input.checked;
    if (input.checked) {
      if (msg) msg.focus();
    } else if (msg && msg.value.trim()) {
      msg.value = '';
      giftCount(msg);
      giftSave('');
    }
  }
  function giftCount(msg) {
    var panel = msg.closest('[data-dvb-gift]');
    var count = panel && $('[data-dvb-gift-count]', panel);
    if (count) count.textContent = msg.value.length + '/' + (msg.getAttribute('maxlength') || 250);
  }

  /* --------------------------------------------------- delivery date */
  /* The same rule as the product page (assets/pdp-guide.js): today in India
     + preparation days + Shipway transit days for the pincode. The transit
     comes from settings.edd_endpoint when the theme has one, otherwise from
     assets/dv-shipway-transit.json. No figure, no date. */
  var transitTables = {};
  var eddCache = {};
  function istToday() {
    var p = {};
    try {
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', year: 'numeric', month: 'numeric', day: 'numeric' })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
    } catch (e) {
      var d = new Date();
      return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    }
  }
  function eddDate(days) {
    var d = istToday();
    d.setUTCDate(d.getUTCDate() + days);
    try { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }); }
    catch (e) { return d.toUTCString().slice(0, 11); }
  }
  function loadTransit(url) {
    if (!url) return Promise.resolve(null);
    if (!transitTables[url]) {
      transitTables[url] = fetch(url, { credentials: 'omit', headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (tbl) { return tbl && tbl.days ? tbl : null; })
        .catch(function () { delete transitTables[url]; return null; });
    }
    return transitTables[url];
  }
  function fromTable(tbl, pin) {
    if (!tbl || !tbl.days) return null;
    var d = tbl.days[pin.slice(0, 3)];
    if (typeof d !== 'number' && tbl.regions) d = tbl.regions[pin.slice(0, 2)];
    return typeof d === 'number' ? { serviceable: true, transit_days: d } : { unknown: true };
  }
  function eddParts(box) {
    return {
      out: $('[data-dvb-edd-out]', box),
      form: $('[data-dvb-edd-form]', box),
      input: $('[data-dvb-edd-pin]', box),
      change: $('[data-dvb-edd-change]', box),
      btn: $('[data-dvb-edd-btn]', box)
    };
  }
  function eddMessage(box, text, tone) {
    var p = eddParts(box);
    p.out.innerHTML = '';
    var para = document.createElement('p');
    para.className = 'dvb-edd__hint' + (tone ? ' is-' + tone : '');
    para.textContent = text;
    p.out.appendChild(para);
    p.form.hidden = false;
    p.change.hidden = true;
    box.classList.remove('is-known');
  }
  function eddShow(box) {
    var p = eddParts(box);
    var pin = box.__pin;
    var transit = box.__transit;
    if (!pin || typeof transit !== 'number') return;
    var prep = parseInt(box.getAttribute('data-prep'), 10);
    if (!(prep >= 0)) prep = 3;
    p.out.innerHTML = '';
    var date = document.createElement('p');
    date.className = 'dvb-edd__date';
    var k = document.createElement('span');
    k.textContent = t('arrives') + ' ';
    var b = document.createElement('b');
    b.textContent = eddDate(prep + transit);
    date.appendChild(k);
    date.appendChild(b);
    var to = document.createElement('p');
    to.className = 'dvb-edd__to';
    to.textContent = t('to') + ' ' + pin;
    p.out.appendChild(date);
    p.out.appendChild(to);
    var win = (box.getAttribute('data-window') || '').trim();
    if (win) {
      var note = document.createElement('p');
      note.className = 'dvb-edd__note';
      note.textContent = t('window_note', { title: box.getAttribute('data-window-title') || '', days: win });
      p.out.appendChild(note);
    }
    p.form.hidden = true;
    p.change.hidden = false;
    box.classList.add('is-known');
  }
  function eddCheck(box, pin, quiet) {
    var p = eddParts(box);
    pin = String(pin || '').replace(/\s+/g, '');
    if (!/^[1-9][0-9]{5}$/.test(pin)) {
      if (!quiet) { eddMessage(box, t('pin_invalid'), 'error'); p.input.focus(); }
      return;
    }
    try { window.localStorage.setItem(PIN_KEY, pin); } catch (e) { /* private mode */ }
    var endpoint = (box.getAttribute('data-endpoint') || '').trim();
    var transitUrl = (box.getAttribute('data-transit') || '').trim();
    var weight = (box.getAttribute('data-weight') || '').trim();
    var seq = (box.__seq = (box.__seq || 0) + 1);
    function answer(r) {
      if (seq !== box.__seq) return;
      box.removeAttribute('aria-busy');
      if (r && r.serviceable === true && typeof r.transit_days === 'number' && r.transit_days >= 0 && r.transit_days < 60) {
        box.__pin = pin;
        box.__transit = Math.round(r.transit_days);
        eddShow(box);
        rememberPin(box, pin);
      } else if (r && r.serviceable === false) {
        box.__transit = null; eddMessage(box, t('pin_none'), 'error');
      } else if (r && r.unknown) {
        box.__transit = null; eddMessage(box, t('pin_unknown'), 'error');
      } else {
        box.__transit = null; eddMessage(box, t('pin_error'), 'error');
      }
    }
    var cacheKey = pin + '|' + weight;
    if (eddCache[cacheKey]) { answer(eddCache[cacheKey]); return; }
    box.setAttribute('aria-busy', 'true');
    if (!quiet) eddMessage(box, t('pin_checking'), 'busy');
    function viaTable() {
      return loadTransit(transitUrl).then(function (tbl) {
        var r = fromTable(tbl, pin);
        if (r) eddCache[cacheKey] = r;
        answer(r);
      });
    }
    if (!endpoint) { viaTable(); return; }
    var url = endpoint + (endpoint.indexOf('?') === -1 ? '?' : '&') + 'pin=' + pin + (weight ? '&w=' + encodeURIComponent(weight) : '');
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl ? window.setTimeout(function () { ctl.abort(); }, 12000) : 0;
    fetch(url, { credentials: 'omit', headers: { 'Accept': 'application/json' }, signal: ctl ? ctl.signal : undefined })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
      .then(function (r) {
        window.clearTimeout(timer);
        if (r && (r.serviceable === false || (r.serviceable === true && typeof r.transit_days === 'number'))) {
          eddCache[cacheKey] = r; answer(r); return null;
        }
        return viaTable();
      })
      .catch(function () { window.clearTimeout(timer); return viaTable(); });
  }
  /* The header's "Deliver to" and its PIN dialog read the pincode from the
     cart (dv_ship_pin). Keep them in step with the one checked here. The
     stored state and rate belonged to the previous pincode, so they are
     cleared rather than left to describe somewhere else. */
  function rememberPin(box, pin) {
    $$('[data-dv-location]').forEach(function (btn) {
      var label = $('[data-dv-location-label]', btn);
      if (label) label.textContent = (btn.getAttribute('data-label-deliver') || 'Deliver to') + ' ' + pin;
    });
    if ((box.getAttribute('data-stored-pin') || '') === pin) return;
    box.setAttribute('data-stored-pin', pin);
    /* Not cartPost: nothing about the total changes, so the summary is not
       dimmed while this is written. */
    queue(function () {
      return fetch(ROOT + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { dv_ship_pin: pin, dv_ship_province: '', dv_ship_rate: '', dv_ship_name: '' } })
      }).then(function (r) { if (!r.ok) throw new Error(r.status); });
    }).catch(function () { box.setAttribute('data-stored-pin', ''); });
  }
  function initEdd() {
    var box = $('[data-dvb-edd]');
    if (!box || box.__init) return;
    box.__init = true;
    var p = eddParts(box);
    var start = (box.getAttribute('data-pin') || '').trim();
    if (!start) { try { start = window.localStorage.getItem(PIN_KEY) || ''; } catch (e) { start = ''; } }
    if (/^[1-9][0-9]{5}$/.test(start)) {
      p.input.value = start;
      eddCheck(box, start, true);
    }
  }
  /* After a re-render: a new item can change the preparation days, and the
     header's PIN dialog can change the pincode. */
  function syncEdd(live, fresh) {
    var a = $('[data-dvb-edd]', live);
    var b = $('[data-dvb-edd]', fresh);
    if (!a || !b) return;
    var changed = false;
    ['data-prep', 'data-weight', 'data-window', 'data-window-title'].forEach(function (name) {
      var v = b.getAttribute(name) || '';
      if ((a.getAttribute(name) || '') !== v) { a.setAttribute(name, v); changed = true; }
    });
    a.setAttribute('data-stored-pin', b.getAttribute('data-stored-pin') || '');
    var newPin = (b.getAttribute('data-pin') || '').trim();
    if (newPin && newPin !== (a.getAttribute('data-pin') || '').trim()) {
      a.setAttribute('data-pin', newPin);
      eddParts(a).input.value = newPin;
      eddCheck(a, newPin, true);
      return;
    }
    if (changed && a.classList.contains('is-known')) eddShow(a);
  }

  /* --------------------------------------------------------------- rails */
  function bagProductIds() {
    var ids = {};
    $$('[data-dvb-line]').forEach(function (li) {
      if (!li.classList.contains('is-leaving')) ids[li.getAttribute('data-product-id')] = true;
    });
    return ids;
  }
  function railNav(host) {
    var track = $('[data-dvb-rail-track]', host);
    var prev = $('[data-dvb-rail-prev]', host);
    var next = $('[data-dvb-rail-next]', host);
    if (!track || !prev || !next) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max;
    var nav = prev.parentNode;
    if (nav) nav.hidden = max <= 0;
  }
  function filterRail(host) {
    if (!host) return;
    var inBag = bagProductIds();
    $$('[data-dvb-rail-track] > li', host).forEach(function (li) {
      var card = li.querySelector('[data-product-id]');
      var id = card && card.getAttribute('data-product-id');
      li.hidden = !!(id && inBag[id]);
    });
    host.hidden = !$$('[data-dvb-rail-track] > li:not([hidden])', host).length;
    railNav(host);
  }
  function fetchRecs(productId, intent) {
    var url = ROOT + 'recommendations/products?section_id=' + RECS_SECTION
      + '&product_id=' + encodeURIComponent(productId) + '&limit=10&intent=' + intent;
    return fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return [];
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return $$('[data-dv-xsell] .dv-xsell__list > li', doc).map(function (li) { return document.importNode(li, true); });
      })
      .catch(function () { return []; });
  }
  var recsFor = null;
  function loadRecs(force) {
    var host = $('[data-dvb-recs]');
    if (!host) return;
    var first = null;
    $$('[data-dvb-line]').some(function (li) {
      if (!li.classList.contains('is-leaving')) { first = li; return true; }
      return false;
    });
    var pid = first && first.getAttribute('data-product-id');
    if (!pid) { host.hidden = true; recsFor = null; return; }
    if (pid === recsFor && !force) { filterRail(host); return; }
    recsFor = pid;
    fetchRecs(pid, 'complementary')
      .then(function (items) { return items.length ? items : fetchRecs(pid, 'related'); })
      .then(function (items) {
        if (recsFor !== pid) return;
        var track = $('[data-dvb-rail-track]', host);
        track.innerHTML = '';
        items.forEach(function (li) { track.appendChild(li); });
        filterRail(host);
        document.dispatchEvent(new CustomEvent('dv:section:loaded'));
        if (window.DirevulfWishlist) window.DirevulfWishlist.render();
      });
  }
  function fetchWishCard(handle) {
    var url = base() + '/products/' + encodeURIComponent(handle) + '?section_id=' + WISH_SECTION;
    return fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('[data-dv-product-card]');
        return card ? document.importNode(card, true) : null;
      })
      .catch(function () { return null; });
  }
  var wishRun = 0;
  var wishSig = '';
  function loadWishRail() {
    var host = $('[data-dvb-wishrail]');
    if (!host || !window.DirevulfWishlist) return;
    var inBag = bagProductIds();
    var list = window.DirevulfWishlist.list().filter(function (e) {
      return e && e.handle && !inBag[String(e.id)];
    }).slice(0, 8);
    var run = ++wishRun;
    var track = $('[data-dvb-rail-track]', host);
    if (!list.length) { track.innerHTML = ''; host.hidden = true; return; }
    Promise.all(list.map(function (e) { return fetchWishCard(e.handle); })).then(function (cards) {
      if (run !== wishRun) return;
      track.innerHTML = '';
      cards.forEach(function (card) {
        if (!card) return;
        var li = document.createElement('li');
        li.appendChild(card);
        track.appendChild(li);
      });
      host.hidden = !track.children.length;
      railNav(host);
      document.dispatchEvent(new CustomEvent('dv:section:loaded'));
      window.DirevulfWishlist.render();
    });
  }
  function bagSig() { return Object.keys(bagProductIds()).sort().join(','); }

  /* ------------------------------------------------------- sticky bar */
  var barIO = null;
  function initBar() {
    var bar = $('[data-dvb-bar]');
    if (!bar || bar.__init) return;
    bar.__init = true;
    if (barIO) { barIO.disconnect(); barIO = null; }
    var cta = $('[data-dvb-cta]');
    if (cta && 'IntersectionObserver' in window) {
      barIO = new IntersectionObserver(function (entries) {
        var seen = entries.some(function (e) { return e.isIntersecting; });
        var live = $('[data-dvb-bar]');
        if (live && !live.classList.contains('is-open')) live.classList.toggle('is-tucked', seen);
      }, { threshold: 0.6 });
      barIO.observe(cta);
    }
  }
  function toggleBar(open) {
    var bar = $('[data-dvb-bar]');
    if (!bar) return;
    var sheet = $('[data-dvb-bar-sheet]', bar);
    var btn = $('[data-dvb-bar-toggle]', bar);
    var want = typeof open === 'boolean' ? open : !bar.classList.contains('is-open');
    bar.classList.toggle('is-open', want);
    if (want) bar.classList.remove('is-tucked');
    if (sheet) sheet.hidden = !want;
    if (btn) btn.setAttribute('aria-expanded', String(want));
  }

  /* Sticky summary sits just under the sticky site header. */
  var measureQueued = false;
  function measureHeader() {
    if (measureQueued) return;
    measureQueued = true;
    window.requestAnimationFrame(function () {
      measureQueued = false;
      var r = root();
      var head = $('.dv-header-section');
      if (!r || !head) return;
      var top = parseFloat(window.getComputedStyle(head).top) || 0;
      var h = head.getBoundingClientRect().height + Math.min(0, top);
      r.style.setProperty('--dvb-sticky', Math.max(0, Math.round(h)) + 'px');
    });
  }

  /* ------------------------------------------------- in-place re-render */
  function rememberFocus() {
    var a = document.activeElement;
    var r = root();
    if (!a || !r || !r.contains(a) || a === document.body) return null;
    var li = lineOf(a);
    return { f: a.getAttribute('data-dvb-f'), id: a.id, key: li ? li.getAttribute('data-key') : null, el: a };
  }
  function restoreFocus(m) {
    if (!m) return;
    if (m.el && document.contains(m.el)) return;
    var r = root();
    var target = null;
    if (m.key && m.f) {
      var li = byKey(r, m.key);
      target = li && $('[data-dvb-f="' + m.f + '"]', li);
      if (target && target.disabled) target = $('[data-dvb-f="plus"]', li);
    } else if (m.id) {
      target = document.getElementById(m.id);
    } else if (m.f) {
      target = $('[data-dvb-f="' + m.f + '"]', r);
    }
    if (target && !target.disabled) target.focus({ preventScroll: true });
  }
  function copyAttrs(from, to) {
    Array.prototype.forEach.call(from.attributes, function (a) {
      if (to.getAttribute(a.name) !== a.value) to.setAttribute(a.name, a.value);
    });
  }
  function partNames(node) {
    return $$('[data-dvb-part]', node).map(function (p) { return p.getAttribute('data-dvb-part'); }).join(',');
  }
  function patchLine(live, fresh) {
    var pending = live.__pending;
    if (partNames(live) !== partNames(fresh)) {
      if (pending) return;
      live.innerHTML = fresh.innerHTML;
      copyAttrs(fresh, live);
      return;
    }
    $$('[data-dvb-part]', fresh).forEach(function (fp) {
      var name = fp.getAttribute('data-dvb-part');
      if (pending && name === 'controls') return;
      var lp = $('[data-dvb-part="' + name + '"]', live);
      if (lp && lp.innerHTML !== fp.innerHTML) { lp.innerHTML = fp.innerHTML; copyAttrs(fp, lp); }
    });
    var keepQty = pending ? live.getAttribute('data-qty') : null;
    copyAttrs(fresh, live);
    if (keepQty) live.setAttribute('data-qty', keepQty);
    if (!pending) live.classList.remove('is-busy');
  }
  function patchLines(live, fresh) {
    var list = $('[data-dvb-lines]', live);
    var flist = $('[data-dvb-lines]', fresh);
    if (!list || !flist) return;
    var liveMap = {};
    $$('[data-dvb-line]', list).forEach(function (li) {
      if (!li.classList.contains('is-leaving')) liveMap[li.getAttribute('data-key')] = li;
    });
    var keep = {};
    var prev = null;
    var entering = [];
    $$('[data-dvb-line]', flist).forEach(function (fl) {
      var key = fl.getAttribute('data-key');
      keep[key] = true;
      var node = liveMap[key];
      if (node) {
        patchLine(node, fl);
      } else {
        node = document.importNode(fl, true);
        if (!REDUCE) { node.classList.add('is-entering'); entering.push(node); }
      }
      var want = prev ? prev.nextSibling : list.firstChild;
      if (want !== node) list.insertBefore(node, want);
      prev = node;
    });
    if (entering.length) {
      /* Lay the new lines out in their hidden state, then let them fade in.
         A forced layout rather than requestAnimationFrame, so a line can never
         be left invisible in a tab that is not painting. */
      void list.offsetHeight;
      entering.forEach(function (n) { n.classList.remove('is-entering'); });
    }
    Object.keys(liveMap).forEach(function (key) {
      if (!keep[key]) collapse(liveMap[key]);
    });
  }
  function swapAll(live, fresh) {
    var kept = {};
    $$('[data-dvb-persist]', live).forEach(function (n) { kept[n.getAttribute('data-dvb-persist')] = n; });
    live.innerHTML = fresh.innerHTML;
    copyAttrs(fresh, live);
    Object.keys(kept).forEach(function (name) {
      var slot = $('[data-dvb-persist="' + name + '"]', live);
      if (slot) slot.parentNode.replaceChild(kept[name], slot);
    });
  }
  function apply(fresh) {
    var live = root();
    if (!live || !fresh) return;
    var focus = rememberFocus();
    if (live.getAttribute('data-dvb-state') !== fresh.getAttribute('data-dvb-state')) {
      swapAll(live, fresh);
      readConfig();
      afterRender(true);
      restoreFocus(focus);
      return;
    }
    live.setAttribute('data-dvb-count', fresh.getAttribute('data-dvb-count') || '0');
    patchLines(live, fresh);
    $$('[data-dvb-region]', fresh).forEach(function (fr) {
      var name = fr.getAttribute('data-dvb-region');
      var lr = $('[data-dvb-region="' + name + '"]', live);
      if (!lr) return;
      if (lr.innerHTML !== fr.innerHTML) {
        lr.innerHTML = fr.innerHTML;
        if (!REDUCE) {
          lr.classList.remove('is-updated');
          void lr.offsetWidth;
          lr.classList.add('is-updated');
        }
      }
      copyAttrs(fr, lr);
    });
    syncEdd(live, fresh);
    restoreFocus(focus);
    afterRender(false);
  }
  function afterRender(full) {
    initEdd();
    initBar();
    measureHeader();
    if (full) {
      if ($('[data-dvb-saved]') && !$('[data-dvb-saved-list] > *')) renderSaved();
      closeShare();
    }
    loadRecs(false);
    var sig = bagSig();
    if (sig !== wishSig) { wishSig = sig; loadWishRail(); }
    if (window.DirevulfWishlist) window.DirevulfWishlist.render();
  }

  /* -------------------------------------------------------------- wiring */
  document.addEventListener('click', function (event) {
    var r = root();
    if (!r && !event.target.closest('[data-dvb-toast]')) return;
    var el;

    if ((el = event.target.closest('[data-dvb-toast-act]'))) {
      var fn = toastFn;
      hideToast();
      toastFn = null;
      if (fn) fn();
      return;
    }
    if (!r) return;

    if ((el = event.target.closest('[data-dvb-step]'))) { event.preventDefault(); if (!el.disabled) onStep(el); return; }
    if ((el = event.target.closest('[data-dvb-remove]'))) { event.preventDefault(); var rl = lineOf(el); if (rl && !rl.classList.contains('is-leaving')) onRemove(rl); return; }
    if ((el = event.target.closest('[data-dvb-save]'))) { event.preventDefault(); var sl = lineOf(el); if (sl && !sl.classList.contains('is-leaving')) onSave(sl); return; }
    if ((el = event.target.closest('[data-dvb-wish]'))) { event.preventDefault(); var wl = lineOf(el); if (wl && !wl.classList.contains('is-leaving')) onWish(wl); return; }
    if ((el = event.target.closest('[data-dvb-code-remove]'))) { event.preventDefault(); onCouponRemove(el.getAttribute('data-dvb-code-remove')); return; }
    if ((el = event.target.closest('[data-dvb-saved-add]'))) { event.preventDefault(); onSavedAdd(el.closest('[data-dvb-card]')); return; }
    if ((el = event.target.closest('[data-dvb-saved-drop]'))) { event.preventDefault(); onSavedDrop(el.closest('[data-dvb-card]')); return; }
    if ((el = event.target.closest('[data-dvb-shared-add]'))) { event.preventDefault(); onSharedAdd(el.closest('[data-dvb-shared]')); return; }
    if ((el = event.target.closest('[data-dvb-shared-dismiss]'))) {
      event.preventDefault();
      var sh = el.closest('[data-dvb-shared]');
      if (sh) sh.hidden = true;
      stripShared();
      return;
    }
    if ((el = event.target.closest('[data-dvb-share-open]'))) { event.preventDefault(); onShareOpen(el); return; }
    if ((el = event.target.closest('[data-dvb-share-copy]'))) {
      event.preventDefault();
      var link = shareUrl();
      copyText(link).then(function () { closeShare(); toast(t('link_copied')); }, function () { showLinkField(link); });
      return;
    }
    if ((el = event.target.closest('[data-dvb-share-wa]'))) {
      event.preventDefault();
      window.open('https://wa.me/?text=' + encodeURIComponent(t('share_text') + ' ' + shareUrl()), '_blank', 'noopener');
      closeShare();
      return;
    }
    if ((el = event.target.closest('[data-dvb-edd-change]'))) {
      event.preventDefault();
      var box = el.closest('[data-dvb-edd]');
      var p = eddParts(box);
      p.form.hidden = false;
      el.hidden = true;
      p.input.focus();
      p.input.select();
      return;
    }
    if ((el = event.target.closest('[data-dvb-bar-toggle]'))) { event.preventDefault(); toggleBar(); return; }
    if ((el = event.target.closest('[data-dvb-rail-prev], [data-dvb-rail-next]'))) {
      event.preventDefault();
      var host = el.closest('.dvb-rail');
      var track = host && $('[data-dvb-rail-track]', host);
      if (!track) return;
      var dir = el.hasAttribute('data-dvb-rail-next') ? 1 : -1;
      track.scrollBy({ left: dir * Math.max(200, track.clientWidth * 0.85), behavior: REDUCE ? 'auto' : 'smooth' });
      return;
    }

    /* A click anywhere else closes the share menu. */
    if (!event.target.closest('[data-dvb-share]')) closeShare();
  });

  document.addEventListener('change', function (event) {
    if (!root()) return;
    var el;
    if ((el = event.target.closest('[data-dvb-size]'))) { onSize(el); return; }
    if ((el = event.target.closest('[data-dvb-gift-toggle]'))) { onGiftToggle(el); return; }
  });

  document.addEventListener('input', function (event) {
    if (!root()) return;
    var el;
    if ((el = event.target.closest('[data-dvb-gift-msg]'))) {
      giftCount(el);
      window.clearTimeout(giftTimer);
      var value = el.value;
      giftTimer = window.setTimeout(function () { giftSave(value); }, 800);
      return;
    }
    if ((el = event.target.closest('[data-dvb-edd-pin]'))) {
      var clean = el.value.replace(/[^0-9]/g, '').slice(0, 6);
      if (clean !== el.value) el.value = clean;
    }
  });

  document.addEventListener('focusout', function (event) {
    var el = event.target.closest && event.target.closest('[data-dvb-gift-msg]');
    if (!el) return;
    window.clearTimeout(giftTimer);
    giftSave(el.value);
  });

  document.addEventListener('submit', function (event) {
    if (!root()) return;
    var form;
    if ((form = event.target.closest('[data-dvb-coupon-form]'))) { event.preventDefault(); onCoupon(form); return; }
    if ((form = event.target.closest('[data-dvb-edd-form]'))) {
      event.preventDefault();
      var box = form.closest('[data-dvb-edd]');
      eddCheck(box, eddParts(box).input.value, false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !root()) return;
    var menu = $('[data-dvb-share-menu]');
    if (menu && !menu.hidden) { closeShare(); var b = $('[data-dvb-share-open]'); if (b) b.focus(); return; }
    var bar = $('[data-dvb-bar]');
    if (bar && bar.classList.contains('is-open')) { toggleBar(false); var tg = $('[data-dvb-bar-toggle]'); if (tg) tg.focus(); }
  });

  document.addEventListener('scroll', function (event) {
    var track = event.target && event.target.closest ? event.target.closest('[data-dvb-rail-track]') : null;
    if (track) railNav(track.closest('.dvb-rail'));
  }, true);

  document.addEventListener('dv:cart:added', function () { if (root()) toast(t('added')); });
  document.addEventListener('dv:cart:error', function (event) {
    if (root() && event.detail && event.detail.message) toast(event.detail.message);
  });
  document.addEventListener('dv:wishlist:change', function () {
    if (!root()) return;
    window.setTimeout(loadWishRail, 0);
  });

  var toastBox = null;
  function bindToastHover() {
    toastBox = $('[data-dvb-toast]');
    if (!toastBox || toastBox.__bound) return;
    toastBox.__bound = true;
    toastBox.addEventListener('mouseleave', function () { armToast(1600); });
  }

  function init() {
    readConfig();
    if (!root()) return;
    window.DirevulfCartPage = { apply: apply };
    if (window.DirevulfCart && window.DirevulfCart.beforeCheckout) window.DirevulfCart.beforeCheckout(flushForCheckout);
    bindToastHover();
    var gm = $('[data-dvb-gift-msg]');
    if (gm) giftLast = giftNote(gm.value);
    measureHeader();
    initEdd();
    initBar();
    renderSaved();
    renderShared();
    loadRecs(true);
    wishSig = bagSig();
    /* wishlist.js is a deferred script placed after this one, so it may not
       have run yet. Wait for it briefly rather than skipping the rail. */
    (function waitWishlist(tries) {
      if (window.DirevulfWishlist) loadWishRail();
      else if (tries < 50) window.setTimeout(function () { waitWishlist(tries + 1); }, 100);
    })(0);
    window.addEventListener('resize', function () {
      measureHeader();
      $$('.dvb-rail').forEach(railNav);
    }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
